const initialState = {
  data: [],
  success: false,
  error: false,
};

export const reportSave = () => (state = initialState, action) => {
  switch (action.type) {
    case `REPORT_SAVE_REQUEST`: {
      return initialState;
    }
    case `REPORT_SAVE_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `REPORT_SAVE_FAILURE`: {
      return { ...state, data: action.error, success: false, error: true };
    }
    default:
      return state;
  }
};
